import { CancellationEligibility } from '../types'

interface CanCancelInput {
  status: string
  paymentStatus: string | null
  requesterId: string
}

const CANCELLATION_WINDOW_MS = 48 * 60 * 60 * 1000

export const canCancel = (
  joinRequest: CanCancelInput,
  diveStatus: string,
  currentUserId: string | null,
  diveDateTime?: Date
): CancellationEligibility => {
  if (!currentUserId) {
    return { eligible: false, reason: 'NOT_AUTHENTICATED' }
  }

  if (currentUserId !== joinRequest.requesterId) {
    return { eligible: false, reason: 'NOT_AUTHORIZED' }
  }

  if (joinRequest.status !== 'approved') {
    return { eligible: false, reason: 'INVALID_STATE' }
  }

  if (diveStatus === 'completed' || diveStatus === 'cancelled') {
    return { eligible: false, reason: 'DIVE_NOT_ACTIVE' }
  }

  if (
    diveDateTime &&
    diveDateTime.getTime() - Date.now() < CANCELLATION_WINDOW_MS
  ) {
    return { eligible: false, reason: 'TOO_CLOSE_TO_DIVE' }
  }

  if (joinRequest.paymentStatus === 'paid') {
    return { eligible: true, refundType: 'guided' }
  }

  if (joinRequest.paymentStatus === null) {
    return { eligible: true, refundType: 'buddy' }
  }

  return { eligible: false, reason: 'INVALID_STATE' }
}
